import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { Image } from "lucide-react";
import { Eyebrow } from "../components/Buttons";
import { Stagger } from "../components/Reveal";
import { fadeUp, EASE } from "../motion";

export default function About() {
  const media = useRef(null);
  const { scrollYProgress } = useScroll({
    target: media,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section className="about section" id="about">
      <div className="container about__inner">
        <Stagger className="about__copy" gap={0.12}>
          <motion.div variants={fadeUp}>
            <Eyebrow>OUR STORY</Eyebrow>
          </motion.div>
          <motion.h2 variants={fadeUp} className="about__title">
            A better kind of nail salon — quiet, relaxed &amp; genuinely caring.
          </motion.h2>
          <motion.p variants={fadeUp}>
            We started No. 1 Nails &amp; Spa Manly in 2009 because we wanted to
            change how nail salons work. We were tired of rushed services in
            busy, loud shops. The people of Manly deserved something better — a
            salon that is quiet, relaxing, and focused on quality above
            everything.
          </motion.p>
          <motion.p variants={fadeUp}>
            Your health and safety matter deeply to us. We use only the world's
            finest skin-safe products and maintain the highest hygiene standards
            — every client, every time. If you are not 100% happy, we will
            always make it right.
          </motion.p>
        </Stagger>
        <motion.div
          ref={media}
          className="about__media"
          aria-hidden="true"
          initial={{ opacity: 0, clipPath: "inset(12% 12% 12% 12%)" }}
          whileInView={{ opacity: 1, clipPath: "inset(0% 0% 0% 0%)" }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: EASE }}
        >
          <motion.div className="placeholder" style={{ y }}>
            <img src="/no1/front1.jpg" />
            <span>Salon interior — owner-supplied</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
